module.exports = __webpack_public_path__ + "static/media/profile-humanitarian-user.5896fb47.svg";